import Grid from "@material-ui/core/Grid";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userDetail } from "../../../config/userDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  getContractLicenseList,
  getDashboardList,
  getTicketLicenseList,
  getLoginLicenseList,
  getInventoryStatus
} from "../../../modules/dashboard/action";
import { getCommodityData } from "../../../modules/inventorystatus/action";
import { getSubscriptionPlan } from "../../../modules/subscription/action";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin, isAuthorized,isCounterParty } from "../../Common/CheckAuthorization";
import SummaryCard from "../../FormElement/SummaryCard";
import CreateTable from "../../CreateTable";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";
import CommodityBreakdownTable from "./CommodityBreakdownTable";
import Loader from "../../Loader";
import {
  faFileContract,
  faTicketAlt,
  faTractor,
  faUsers
} from "@fortawesome/free-solid-svg-icons";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const closeButtonStyle = {
  position: "absolute",
  right: 2,
  top: 2
};

class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptionLists: [],
      planId: userDetail().planId,
      categoryRows: {
        commodity: { name: "", cell: 1 },
        inventory: { name: "Farm Inventory", cell: 2 },
        contracted: { name: "", cell: 1 },
        deliveredBushels: { name: "Estimated Delivered Bushels", cell: 2 },
        reconciledBushels: { name: "Reconciled Delivered Bushels", cell: 2 }
      },
      headerRows: {
        commodity: "Commodity",
        inventoryUsingEstBushels: "Using Estimated Bushels",
        inventoryUsingReconciledBushels: "Using Reconciled Bushels",
        bushelsContracted: "Bushels Contracted"
      },
      order: "desc",
      orderBy: "",
      dynamicCols: {},
      incomingFillOption: this.props.PrefencesList
        ? this.props.PrefencesList["incomingFillOption"]
          ? this.props.PrefencesList["incomingFillOption"]
          : "incommingEstimatedHomeScaleShrinkBushels"
        : "incommingEstimatedHomeScaleShrinkBushels",
      outgoingFillOption: this.props.PrefencesList
        ? this.props.PrefencesList["outgoingFillOption"]
          ? this.props.PrefencesList["outgoingFillOption"]
          : "outgoingEstimatedHomeScaleShrinkBushels"
        : "outgoingEstimatedHomeScaleShrinkBushels"
    };
  }

  // static getDerivedStateFromProps(props, state) {
  //   return {
  //     ...state,
  //     incomingFillOption: props.PrefencesList
  //       ? props.PrefencesList["incomingFillOption"]
  //         ? props.PrefencesList["incomingFillOption"]
  //         : "incommingEstimatedHomeScaleShrinkBushels"
  //       : "incommingEstimatedHomeScaleShrinkBushels",
  //     outgoingFillOption: props.PrefencesList
  //       ? props.PrefencesList["outgoingFillOption"]
  //         ? props.PrefencesList["outgoingFillOption"]
  //         : "outgoingEstimatedHomeScaleShrinkBushels"
  //       : "outgoingEstimatedHomeScaleShrinkBushels"
  //   };
  // }

  componentDidMount() {
    const { incomingFillOption, outgoingFillOption } = this.state;
    const headerCols = this.updateHeaderCols(
      incomingFillOption,
      outgoingFillOption
    );
    this.setState(prevState => {
      return {
        headerRows: {
          ...prevState.headerRows,
          ...headerCols
        },
        dynamicCols: { ...headerCols }
      };
    });
    if(!isCounterParty()){
    this.props.actions.getDashboardList();
    this.props.actions.getContractLicenseList();
    this.props.actions.getTicketLicenseList();
    this.props.actions.getLoginLicenseList();
    this.props.actions.getSubscriptionPlan();
    this.props.actions.getInventoryStatus();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id &&
      this.props.MainFarmId !== nextProps.MainFarmId
    ) {
      this.props.actions.getDashboardList();
      this.props.actions.getContractLicenseList();
      this.props.actions.getTicketLicenseList();
      this.props.actions.getLoginLicenseList();
      this.props.actions.getInventoryStatus();
    }
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      this.props.actions.getDashboardList();
      this.props.actions.getContractLicenseList();
      this.props.actions.getTicketLicenseList();
      this.props.actions.getLoginLicenseList();
      this.props.actions.getInventoryStatus();
    }
    if (
      nextProps.subscriptionList &&
      this.props.subscriptionList !== nextProps.subscriptionList
    ) {
      this.setState({ subscriptionLists: nextProps.subscriptionList });
    }
  }

  handleClick = (...rest) => {
    const commodityName = rest[rest.length - 1];
    this.props.actions.getCommodityData(commodityName);
    this.setState({
      open: true,
      commodityName: commodityName
    });
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      commodityName: ""
    });
  };

  updateHeaderCols = (incomingFillOption, outgoingFillOption) => {
    const headerCols = {};
    console.log(incomingFillOption,outgoingFillOption,"inout");
    if (incomingFillOption.includes("Home")) {
      headerCols.totalFieldHomeShrinkBushels = "Field";
    } else {
      headerCols.totalFieldLoadBushels = "Field";
    }
    if (outgoingFillOption.includes("Home")) {
      headerCols.totalOnsiteHomeShrinkBushels = "On site";
    } else {
      headerCols.totalOnsiteLoadBushels = "Onsite";
    }
    headerCols.totalReconciledFieldBushels = "Field";
    headerCols.totalReconciledOnsiteBushels = "On site";

    return headerCols;
  };

  render() {
    const { ContractLicenseList, TicketLicenseList } = this.props;
    const { LoginLicenseList } = this.props;
    const { DashboardList, fetchingComplete, inventoryList = [] } = this.props;
    const { categoryRows, order, orderBy, commodityName } = this.state;
    const { incomingFillOption, outgoingFillOption, open } = this.state;
    const { headerRows, dynamicCols } = this.state;
    console.log(ContractLicenseList, TicketLicenseList, LoginLicenseList);

    const computedList = [...inventoryList];

    computedList.map(item => {
      item.inventoryUsingEstBushels =
        item[incomingFillOption] - item[outgoingFillOption];
      item.inventoryUsingReconciledBushels =
        item[incomingFillOption] - item.payloadDelivered;

      item.inventoryUsingEstBushels = parseFloat(
        item.inventoryUsingEstBushels || 0
      ).toFixed(2);
      item.inventoryUsingReconciledBushels = parseFloat(
        item.inventoryUsingReconciledBushels || 0
      ).toFixed(2);
    });
    
    var i=0;
    var array = []
    console.log(computedList,"inventoriess");
    for(i=0;i<computedList.length;i++)
    {
      if((computedList[i]["inventoryUsingEstBushels"]!=null && computedList[i]["inventoryUsingEstBushels"]!=0 && computedList[i]["inventoryUsingReconciledBushels"]!="0.00")||
      (computedList[i]["inventoryUsingReconciledBushels"]!=null && computedList[i]["inventoryUsingReconciledBushels"]!=0 && computedList[i]["inventoryUsingReconciledBushels"]!="0.00")||
      (computedList[i]["bushelsContracted"]!=null && computedList[i]["bushelsContracted"]!=0)||
       (computedList[i]["totalFieldHomeShrinkBushels"]!=null && computedList[i]["totalFieldHomeShrinkBushels"]!=0)||
       (computedList[i]["totalFieldLoadBushels"]!=null && computedList[i]["totalFieldLoadBushels"]!=0)||
       (computedList[i]["totalOnsiteHomeShrinkBushels"]!=null && computedList[i]["totalOnsiteHomeShrinkBushels"]!=0)||
       (computedList[i]["totalOnsiteLoadBushels"]!=null && computedList[i]["totalOnsiteLoadBushels"]!=0)||
       (computedList[i]["totalReconciledFieldBushels"]!=null && computedList[i]["totalReconciledFieldBushels"]!=0)||
       (computedList[i]["totalReconciledOnsiteBushels"]!=null && computedList[i]["totalReconciledOnsiteBushels"]!=0)
      )
      {
        array.push(computedList[i]);
      }
    }
    
    return (
      <div className="dashboard-body">
        {isSuperAdmin() &&
        this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog />
        ) : this.props.selectedYear && DashboardList ? (
          <div>
            {fetchingComplete ? (
              <React.Fragment>
                <div style={{ margin: "1em 0em 0em 1em" }}>
                  {`Number of contracts allowed:  ${
                    ContractLicenseList.allowedCount > 9999999
                      ? "Unlimited"
                      : ContractLicenseList.allowedCount
                  }  contracts`}
                </div>

                <div style={{ margin: "0em 1em" }}>
                  {`Number of tickets allowed:  ${
                    TicketLicenseList.allowedCount > 9999999
                      ? "Unlimited"
                      : TicketLicenseList.allowedCount
                  }  tickets`}
                </div>

                <div style={{ margin: "0em 1em" }}>
                  {`Number of users allowed:  ${
                    LoginLicenseList.allowedCount > 9999999
                      ? "Unlimited"
                      : LoginLicenseList.allowedCount
                  }  users`}
                </div>

                <Grid container item xs={12}>
                  <SummaryCard
                    calculatedNumber={DashboardList.userCount}
                    message={"User(s) Created"}
                    icon={faUsers}
                  />
                  <SummaryCard
                    calculatedNumber={DashboardList.farmCount}
                    message={"Farm(s) Created"}
                    icon={faTractor}
                  />
                  <SummaryCard
                    calculatedNumber={DashboardList.contractCount}
                    message={"Harvest Contract(s) Created"}
                    icon={faFileContract}
                  />
                  <SummaryCard
                    calculatedNumber={DashboardList.ticketCount}
                    message={"Harvest Ticket(s) Created"}
                    icon={faTicketAlt}
                  />
                </Grid>
              </React.Fragment>
            ) : (
              <Loader />
            )}
            {isAuthorized() ? (
              <div className=" ticket-body">
                <div className="flex-display ticket-header">
                  <h3 className="mainHeading">NTRAC Harvest Board</h3>
                </div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"md"}
                  open={open}
                  TransitionComponent={Transition}
                  onClose={this.handleClose}
                >
                  <DialogTitle>
                    <Typography variant="h6">
                      {`Breakdown for commodity - ${commodityName}`}
                    </Typography>
                    <IconButton
                      aria-label="Close"
                      style={closeButtonStyle}
                      onClick={this.handleClose}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent>
                    <CommodityBreakdownTable
                      // commodityHeader={headerRows}
                      dynamicCols={dynamicCols}
                      incomingFillOption={incomingFillOption}
                      outgoingFillOption={outgoingFillOption}
                      isSortingRequired={false}
                    />
                  </DialogContent>
                </Dialog>
                <CreateTable
                  order={order}
                  orderBy={orderBy}
                  categoryRows={categoryRows}
                  headerRows={headerRows}
                  //rowData={computedList}
                  rowData={array}
                  onClick={this.handleClick}
                  onRequestSort={this.handleRequestSort}
                  isMenuRequired={false}
                  highlightPrimaryColumn={true}
                  isClickable={true}
                  isBorder
                  fetchingComplete={fetchingComplete}
                />
                <h5>
                  {`Note: Calculation of the above Farm Inventory is done on the basis
            of ${
              incomingFillOption.includes("Home")
                ? "Estimated Home Scale Shrunk"
                : "Field Estimated Load"
            } Bushels.`}
                </h5>
              </div>
            ) : null}
          </div>
        ) : (
          <AllMainFarmSelectedDialog />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    DashboardList: state.dashboardReducer.dashboardList,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    ContractLicenseList: state.dashboardReducer.ContractLicenseList,
    TicketLicenseList: state.dashboardReducer.TicketLicenseList,
    LoginLicenseList: state.dashboardReducer.LoginLicenseList,
    subscriptionList: state.subscriptionList.subscriptionListDetails,
    inventoryList: state.dashboardReducer.inventoryList,
    PrefencesList: state.preferencesReducer.PrefencesList,
    fetchingComplete: state.dashboardReducer.fetchingComplete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getDashboardList,
        getContractLicenseList,
        getTicketLicenseList,
        getLoginLicenseList,
        getSubscriptionPlan,
        getInventoryStatus,
        getCommodityData
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardView);



// WEBPACK FOOTER //
// ./src/components/private/Dashboard/DashboardView.js